import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '分类索引', href: '#index' },
  { label: '精选推荐', href: '#media' },
  { label: '焦点专题', href: '#carousel' },
  { label: '观众热评', href: '#comments' },
  { label: '常见问题', href: '#faq' },
];

export default function Home() {
  return (
    <div className="relative bg-background-50">
      <Header navItems={navItems} />
      <main>
        <HeroSection />
        <CommentsSection />
        <MediaSection />
        <IndexSection />
        <FeaturesSection />
        <ContactSection />
        <CardsSection />
        <TopicsSection />
        <CarouselSection />
        <UpdatesSection />
        <RankingSection />
        <AboutSection />
        <AppSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}